// Count the number of nodes
export default function() {
  return this.reduce((a) => a + 1, 0);
}
